module.exports = __webpack_public_path__ + "img/thumb_orcamento_full.ffacb391.png";